import { PriceCategory } from './priceCategory';

// Define the enum based on backend database.py
export enum AuxiliaireCategoryEnum {
  AIDANT_FAMILIAL = 'Aidant familial',
  EMPLOI_DIRECT = 'Emploi direct',
  PRESTATAIRE = 'Prestataire',
}

export interface Auxiliaire {
  id: number;
  name: string;
  category: AuxiliaireCategoryEnum; // Use the enum
  // Add optional override rates
  hourly_rate?: number | null; // Use number for simplicity, allow null
  nightly_rate?: number | null;
  // Add the nested price category information
  price_category?: PriceCategory | null;
}
